import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import { useFormik } from "formik";
import SVG from "react-inlinesvg";
import InputAdornment from "@material-ui/core/InputAdornment";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as Yup from "yup";
import axios from "axios";
import Preview from "../components/Preview.js";
import { BiCopy } from "react-icons/bi";


const initialValues = {
  // header: "",
  headerAz: "",
  headerEn: "",
  headerRu: "",
  // text: "",
  textAz: "",
  textEn: "",
  textRu: "",
  filePath: "",
};

export default function Create(props) {
  const { show, onHide, onNotifications, skip, take, sortField, orderBy } = props;
  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [file, setFile] = useState("");
  const [isError, setIsError] = useState("");

  const form = useRef(null);



  const CreateSchema = Yup.object().shape({
    // header: Yup.string().required("Header is required"),
    headerAz: Yup.string().required("Header Az is required"),
    headerEn: Yup.string().required("Header En is required"),
    headerRu: Yup.string().required("Header Ru is required"),

    textAz: Yup.string().required("Text Az is required"),
    textEn: Yup.string().required("Text En is required"),
    textRu: Yup.string().required("Text Ru is required"),
    // text: Yup.string().required("Text is required"),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const onPostNotification = (values, resetForm, setSubmitting) => {
    const notification = new FormData(form.current);
    axios
      .post(`${process.env.REACT_APP_API_URL}notification`, notification, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onNotifications(skip, take, sortField, orderBy);
        setPreview(false);
        setImageSrc("");
        setFile("");
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostNotification(values, resetForm, setSubmitting);
    },
  });

  useEffect(() => {
    setIsError("");

  }, [show]);


  const handleCopyName = (name) => {
    const headerAz = formik.values.headerAz;
    formik.setFieldValue(name, headerAz);
  };

  const handleCopyText = (name) => {
    const textAz = formik.values.textAz;
    formik.setFieldValue(name, textAz);
  };




  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                {/* <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="header"
                    name="header"
                    label="Header"
                    placeholder="Header"
                    className="w-100"
                    error={getInputClasses("header")}
                    {...formik.getFieldProps("header")}
                  />
                </div>
                {formik.touched.header && formik.errors.header ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.header}</div>
                  </div>
                ) : null} */}
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="headerAz"
                    label="Header Az"
                    placeholder="Header Az"
                    className="w-100"
                    error={getInputClasses("headerAz")}
                    {...formik.getFieldProps("headerAz")}
                  />
                </div>
                {formik.touched.headerAz && formik.errors.headerAz ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.headerAz}</div>
                  </div>
                ) : null}
              </div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="headerEn"
                    label="Header En"
                    placeholder="Header En"
                    className="w-100"
                    title="Copy from Header az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyName("headerEn")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("headerEn")}
                    {...formik.getFieldProps("headerEn")}
                  />
                </div>
                {formik.touched.headerEn && formik.errors.headerEn ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.headerEn}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="headerRu"
                    label="Header Ru"
                    placeholder="Header Ru"
                    className="w-100"
                    title="Copy from Header az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyName("headerRu")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("headerRu")}
                    {...formik.getFieldProps("headerRu")}
                  />
                </div>
                {formik.touched.headerRu && formik.errors.headerRu ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.headerRu}</div>
                  </div>
                ) : null}

              </div>







              {/* <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="text"
                    name="text"
                    label="Text"
                    placeholder="Text"
                    className="w-100"
                    error={getInputClasses("text")}
                    {...formik.getFieldProps("text")}
                  />
                </div>
                {formik.touched.text && formik.errors.text ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.text}
                    </div>
                  </div>
                ) : null}
              </div> */}

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="textAz"
                    label="Text Az"
                    placeholder="Text Az"
                    className="w-100"
                    error={getInputClasses("textAz")}
                    {...formik.getFieldProps("textAz")}
                  />
                </div>
                {formik.touched.textAz && formik.errors.textAz ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.textAz}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="textEn"
                    label="Text En"
                    placeholder="Text En"
                    className="w-100"
                    title="Copy from Text az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyText("textEn")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("textEn")}
                    {...formik.getFieldProps("textEn")}
                  />
                </div>
                {formik.touched.textEn && formik.errors.textEn ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.textEn}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="textRu"
                    label="Text Ru"
                    placeholder="Text Ru"
                    className="w-100"
                    title="Copy from Text az"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ cursor: "pointer" }}
                        >
                          <BiCopy
                            onClick={() => handleCopyText("textRu")}
                            style={{ width: "17px", height: "17px", color: "grey" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    error={getInputClasses("textRu")}
                    {...formik.getFieldProps("textRu")}
                  />
                </div>
                {formik.touched.textRu && formik.errors.textRu ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.textRu}</div>
                  </div>
                ) : null}

              </div>






              <div className="col-12 col-md-12 col-lg-12 mt-3">
                <div className="w-100 pt-2 pb-3">
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      name="file"
                      label="File {Path}"
                      placeholder="File Path"
                      className="w-100"
                      onChange={imagePreview}
                      value={file}
                      hidden
                    />
                    <Button2 variant="contained" component="span">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Upload image
                    </Button2>
                  </label>
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                </div>
                {formik.touched.filePath && formik.errors.filePath ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.filePath}
                    </div>
                  </div>
                ) : null}

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>

            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal >
  );
}
